export default __webpack_public_path__ + "static/media/messaging2.b5e3ab2a.jpg";